export default "__VITE_ASSET__COdBQHS1__"